<i [outerHTML]="icon"></i><ng-content></ng-content>
